import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchProducts = async (params = {}) => {
  const res = await api.get("/products", { params });
  return res.data;
};

export const fetchProduct = async (slug) => {
  const res = await api.get(`/products/${slug}`);
  return res.data;
};

export const subscribeNewsletter = async (email, language = "en") => {
  const res = await api.post("/newsletter/subscribe", { email, language });
  return res.data;
};

export const createOrder = async (payload) => {
  const res = await api.post("/orders", payload);
  return res.data;
};

export const submitContact = async (payload) => {
  const res = await api.post("/contact", payload);
  return res.data;
};

export const validateCoupon = async (code, subtotal) => {
  const res = await api.post("/coupons/validate", { code, subtotal });
  return res.data;
};
